var render, staticRenderFns
import script from "./BarChartRonbun.vue?vue&type=script&lang=js&"
export * from "./BarChartRonbun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28f7a98",
  null
  
)

export default component.exports